module.exports = __webpack_public_path__ + "static/media/42-2.343b0a47.mp3";